export default __webpack_public_path__ + "static/media/my-books-white.0552b1f2.svg";